export enum InputFieldType {
    Text           = "Text",
    Password       = "Password",
    ComboBox       = "ComboBox",
    Select         = "Select",
    Checkbox       = "Checkbox",
    Radio          = "Radio",
    Switch         = "Switch",
    Slider         = "Slider",
    TextArea       = "TextArea",
    File           = "File",
    Color          = "Color",
    Date           = "Date",
    Time           = "Time",
    MiltenyiUpload = "MiltenyiUpload",
    SdlInput       = "SdlInput"
}

export enum StaticFieldType {
    Headline            = "Headline",
    Paragraph           = "Paragraph",
    Image               = "Image",
    Video               = "Video",
    Button              = "Button",
    Plugin              = "Plugin",
    ContributionCounter = "ContributionCounter",
    MiltenyiHeadline    = "MiltenyiHeadline",
    MiltenyiButton      = "MiltenyiButton",
    MiltenyiFooter      = "MiltenyiFooter",
    PageHeader          = "PageHeader",
    PageFooter          = "PageFooter",
    FancyHeadline       = "FancyHeadline",
    FancyButton         = "FancyButton",
    Gdpr                = "Gdpr",
    WazaGdpr            = "WazaGdpr",
    Divider             = "Divider",
    SizableImage        = "SizableImage",
    SiemensGdpr         = "SiemensGdpr",
    TelekomGdpr         = "TelekomGdpr",
    AlexionGdpr         = "AlexionGdpr",
    BayerGdpr           = "BayerGdpr",
    RocheGdpr           = "RocheGdpr",
    BonduelleGdpr       = "BonduelleGdpr",
    SephoraGdpr         = "SephoraGdpr",
    InteractiveMosaic   = "InteractiveMosaic",
    YoutubePlayer       = "YoutubePlayer",
    SncfGdpr            = "SncfGdpr",
    SdlGdpr             = "SdlGdpr",
    FancyParagraph      = "FancyParagraph",
    PortzamparcGdpr     = "PortzamparcGdpr",
    MindozaGdpr         = "MindozaGdpr",
    AltareaGdpr         = "AltareaGdpr",
    ResmedGdpr          = "ResmedGdpr",
    MiltenyiGdpr        = "MiltenyiGdpr",
    SanofiGdpr          = "SanofiGdpr",
    GaldermaGdpr        = "GaldermaGdpr",
    TarkettGdpr         = "TarkettGdpr",
    FullImagePageHeader = "FullImagePageHeader",
    OrangePageFooter    = "OrangePageFooter",
    SlideshowPlugin     = "SlideshowPlugin",
    DanoneGdpr          = "DanoneGdpr",
    UbpGdpr             = "UbpGdpr",
    AbbGdpr             = "AbbGdpr",
    RuvGdpr             = "RuvGdpr",
    GobainGdpr          = "GobainGdpr",
    ManGdpr          = "ManGdpr",
    BobstGdpr          = "BobstGdpr"

}

export enum ButtonAction {
    Submit   = "Submit",
    Link     = "Link",
    Clear    = "Clear",
    Navigate = "Navigate"
}

export type FieldType = StaticFieldType | InputFieldType;

export interface PageScheme {
    backgroundColor: string;
    groups: FieldGroupScheme[];
}

export interface FieldGroupScheme {
    title: string;
    fields: FieldScheme[];
}

export interface FieldScheme {
    type: FieldType;
    name: string;
    placeholder?: string;
    label?: string;
    rules?: string;
    content?: string;
    action?: ButtonAction;
}
